import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavigationUtil } from 'utils/NavigationUtil';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import BeliefStatementsSection from 'components/templates/beliefStatementsSection';
import { ContactUsSection } from 'components/templates/contactUsSection';
import FooterSection from 'components/templates/footer';
import PageTemplate from 'components/templates/pageTemplate';
import { RouteNames } from 'router';
import RenderSEO from 'components/atoms/renderSEO';
import { HeaderButtons } from 'components/atoms/headerButtons';
import { CampaignAction } from 'modules/campaign/action';
import { CampaignSelector } from 'modules/campaign/selector';
import CampaignBanner from 'components/organisms/campaignBanner';
import contact from 'pages/contact';
import { useViewport } from 'components/templates/viewportProvider';
import Testimonial from 'components/templates/testimonial';
import { VideoActions } from 'modules/videos/action';
import { VideosSelector } from 'modules/videos/selector';
import { FooterSelector } from 'modules/footerLink/selector';
import { FooterActions } from 'modules/footerLink/actions';

const CampaignPage = props => {
  const {
    isLoading,
    getPageData,
    cmsPageData,
    cmsMobilePageData,
    getContactDetails,
    contact,
    getVerticals,
    verticals,
    footerLink,
    getFooterLinkData,
    verticalId,
    getSiteSettings,
    siteSettings,
    getCampaignDetails,
    campaignDetails,
    getVideosData,
    videosData,
  } = props;

  const { isMobile } = useViewport();
  const campaign_url_slug = props.match.params.campaignSlug;
  const [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const type = 'campaign';

  useEffect(() => {
    getContactDetails();
    getVerticals();
    getSiteSettings();
    getPageData();
    getFooterLinkData();
    getCampaignDetails(campaign_url_slug);
    getVideosData(11, campaign_url_slug, type);
  }, [campaign_url_slug]);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !cmsMobilePageData ||
    !cmsPageData ||
    !contact ||
    !verticals ||
    !campaignDetails ||
    !videosData ||
    !footerLink
  ) {
    return null;
  }

  const campaignName = get(campaignDetails[0], 'title', '');
  const campaignId = get(campaignDetails[0], 'id', '');
  const metaTagSEO = get(campaignDetails[0], 'metaTagSEO', '');

  const componentList = [
    ...(!isEmpty(campaignDetails)
      ? [
          {
            component: CampaignBanner,
            data: campaignDetails[0],
            origin: 'campaign',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: `${campaignName}`,
                breadcrumbLink: '#',
              },
            ],
            theme: isMobile ? 'dark-theme' : 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(cmsPageData.cms_pages)
      ? [
          {
            component: BeliefStatementsSection,
            data: { cmsPageData, campaignId, type: 'campaign' },
            origin: 'campaign',
            mobileBannerData: { cmsMobilePageData },
            sectionId: 'campaign',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: `${campaignName}`,
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(videosData)
      ? [
          {
            component: Testimonial,
            sectionId: 'videos',
            theme: 'dark-theme',
            data: { testimonialData: videosData, type: 'videos' },
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: campaignName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Videos',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(contact)
      ? [
          {
            component: ContactUsSection,
            data: {
              contact,
              verticals,
              verticalId,
              callPostLeadAPI: true,
              showVerticalDropdown: false,
              origin: 'campaign',
            },
            location: props,
            sectionId: 'contact',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Contact Us',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <>
      <RenderSEO
        metaTags={metaTagSEO}
        currentRouteName={`campaign/${campaign_url_slug}`}
      />
      <PageTemplate
        componentList={componentList}
        theme={theme}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        showGetInTouch={false}
        toggleHeaderItem={true}
        type={'campaign'}
        headerButtons={
          <HeaderButtons
            shareTheme={'dark'}
            getInTouchTheme={'light'}
            showShareButton={false}
            isCampaignPage={true}
          />
        }
      />
    </>
  );
};

const mapStateToProps = (state, props) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);

  return {
    isLoading:
      HomeSelector.isLoading(state) ||
      CampaignSelector.getCampaignDetailsLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      FooterSelector.isLoading(state) ||
      VideosSelector.isLoading(state),
    cmsPageData: CmsPagesSelector.getPageData(state, 'Campaign'),
    cmsMobilePageData: CmsPagesSelector.getCampaignDataMobile(state),
    contact: HomeSelector.getContactForCampaignDetail(state),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    siteSettings: HomeSelector.getSiteSettings(state),
    footerLink: FooterSelector.getFooterData(state),
    verticals: HomeSelector.getVerticals(state),
    campaignDetails: CampaignSelector.getCampaignDetails(state),
    videosData: VideosSelector.getVideosData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getContactDetails, getVerticals, getSiteSettings } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getCampaignDetails } = CampaignAction;
  const { getVideosData } = VideoActions;
  const { getFooterLinkData } = FooterActions;
  return bindActionCreators(
    {
      getContactDetails,
      getVerticals,
      getSiteSettings,
      getPageData,
      getCampaignDetails,
      getVideosData,
      getFooterLinkData,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignPage);
